import React from "react";
import CommonSendComponent from "../../components/CommonSendComponent";
import { SEND_CONFIGS } from "../../config/sendConfigs";

const SendDqrImage = () => {
  return (
    <>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <h1 className="m-0">Send DQR Images</h1>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <CommonSendComponent config={SEND_CONFIGS.dqrImage} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SendDqrImage;
